module.exports={render:function (){with(this) {
  return _h('div', {
    class: {
      showCart: totalNum
    }
  }, [_h('menu-header', {
    attrs: {
      "shop-info": shopInfo,
      "is-searching": isSearching,
      "filter-key": filterKey
    }
  }), " ", _h('transition', {
    attrs: {
      "name": "searchtip"
    }
  }, [_h('search-tip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!filterKey && isSearching),
      expression: "!filterKey&&isSearching"
    }],
    attrs: {
      "tips-data": tipsData
    },
    on: {
      "click-tip": clickTip
    }
  })]), " ", _h('menu-contents', {
    attrs: {
      "show-catalog": showCatalog,
      "active-catalog": activeIndex,
      "dishs-data": dishsData
    }
  }), " ", _h('menu-items', {
    attrs: {
      "filter-data": filterKey,
      "dishs-data": dishsData
    }
  }), " ", _h('transition', {
    attrs: {
      "name": "piccard"
    }
  }, [(showPicCard && picCardSrcs) ? _h('pic-card', {
    attrs: {
      "img-srcs": picCardSrcs
    }
  }) : _e()]), " ", _h('menu-cart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (totalNum),
      expression: "totalNum"
    }],
    attrs: {
      "total-number": totalNum,
      "total-price": totalPri
    }
  })])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-34857ec8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 72
 ** module chunks = 1
 **/